import Vue from 'vue'
import store from '@/store/index';

class Plugin {
    formatDate(date, withTime) {
        if (!date) return null;
        if (isNaN(new Date(date).getTime())) {
            date = new Date(Number(date))
        } else {
            date = new Date(date)
        }
        return (withTime)
            ? `${("0" + date.getDate()).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}::${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`
            : `${("0" + date.getDate()).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
    }
    getIsoLocalTime(date){
        let offset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        return (new Date(date.getTime() - offset)).toISOString()
    }
    translate(def, code, entity) {
        return store.getters.getTranslation(def, code, entity)
    }

    isPerimitted(object, method, type) {
        return store.getters.isPerimitted(object, method, type)
    }

    isReference(value) {
        return ['REF', 'ARR'].includes(value)
    }

    chosenLanguage() {
        return store.getters.getChosenLang;
    }


    initMutation(fields, data) {
        let obj = {}
        for (let field of Object.values(fields)) {
            if (obj[field.value]) continue;
            let value;
            if (data) value = data[field.value]
            obj[field.value] = (value) ? value : '';
            if (field.type === 'REF') obj[field.value] = (value) ? value : {table: field.table};
        }
        return obj;
    }

    prepareArrMutation(initial = [], mutated = []) {
        let initialArr = initial.map(i => i.id)
        let mutatedArr = mutated.map(i => i.id)
        let initialSet = new Set(initialArr);
        let mutatedSet = new Set(mutatedArr);
        let merged = Array.from(new Set([...initialArr, ...mutatedArr]))
        let response = merged.map(item => {
            let obj = {id: item}
            if (!initialSet.has(item)) obj.checked = true
            if (!mutatedSet.has(item)) obj.checked = false
            return obj
        })
        return response.filter(item => item.hasOwnProperty('checked'))
    }

    getCellValue(notParsedValue, type) {
        if ([undefined, null, 'null'].includes(notParsedValue)) return '';
        if (type === 'BOOLEAN') return ((notParsedValue || '').toString() === 'true') ? this.translate('Да', 'yes') : this.translate('Нет', 'no')
        if (type === 'DATE') return this.formatDate(notParsedValue)
        if (type === 'DATE_TIME') return this.formatDate(notParsedValue, 1)
        if (type === 'ARR') return '...';
        if (type === 'REF') return (typeof notParsedValue === 'object') ? notParsedValue.value : '';
        if (type === 'ML') return notParsedValue[this.chosenLanguage()] || notParsedValue['rus']
        if (type === 'JSON') return JSON.stringify(notParsedValue || {})
        if (type.indexOf('OBJECT_KEY')>-1){
            let key = type.slice(type.indexOf('#')+1||1)
            return (typeof notParsedValue === 'object')?notParsedValue[key]:notParsedValue;
        }
        return notParsedValue;
    }

    static install(Vue) {
        Vue.prototype.$helper = new Plugin();
    }
}

Vue.use(Plugin)